export const defaultPromptConfiguration = {
  modelVersion: 'gemini-2.0-flash',
  temperature: 0.2,
  topP: 0.8,
  topK: 40,
  maxOutputTokens: 8000
}

export const llmModelVersions = [
  // Google Gemini
  {
    label: 'Google: Gemini 2.0 Flash',
    value: 'gemini-2.0-flash'
  },
  {
    label: 'Google: Gemini 2.5 Pro',
    value: 'gemini-2.5-pro'
  },
  {
    label: 'Google: Gemini 2.5 Flash',
    value: 'gemini-2.5-flash'
  },
  {
    label: 'Google: Gemini 2.5 Flash Lite',
    value: 'gemini-2.5-flash-lite'
  },

  // Anthropic Claude
  {
    label: 'Anthropic: Claude Opus 4.7 (Preview)',
    value: 'claude-opus-4-7'
  },
  {
    label: 'Anthropic: Claude Sonnet 4.6',
    value: 'claude-sonnet-4-6'
  },
  {
    label: 'Anthropic: Claude Sonnet 4 (Version - 20250514)',
    value: 'claude-sonnet-4@20250514'
  },
  {
    label: 'Anthropic: Claude 3.7 Sonnet (Version - 20250219) ⚠️ Deprecated - Retiring May 11 2026',
    value: 'claude-3-7-sonnet@20250219'
  },
  {
    label: 'Anthropic: Claude Haiku 4.5',
    value: 'claude-haiku-4-5@20251001'
  },

  // Meta Llama
  {
    label: 'Meta: Llama 3.3 70B Instruct (Preview)',
    value: 'meta/llama-3.3-70b-instruct-maas'
  },
  {
    label: 'Meta: Llama 4 Maverick 17B-128E (MoE - Multimodal - Preview)',
    value: 'meta/llama-4-maverick-17b-128e-instruct-maas'
  },
  {
    label: 'Meta: Llama 4 Scout 17B-16E (MoE - Multimodal - Preview)',
    value: 'meta/llama-4-scout-17b-16e-instruct-maas'
  }
]



// WEBPACK FOOTER //
// ./src/components/prompt-management/constants.js